/**
 * Trust metrics shown on homepage (Our Clients), testimonials copy, reviews page, and meta.
 * Update here only — keep numbers consistent sitewide.
 */
export const SITE_TRUST_STATS = [
  { value: '100+', label: 'Clients served' },
  { value: '5+', label: 'Years experience' },
  { value: '1000+', label: 'Manpower deployed' }
];
